module.exports = __webpack_public_path__ + "img/H03085-38.0ce93cc4.jpg";